import { render, staticRenderFns } from "./ChatroomPage.vue?vue&type=template&id=08881cf7&"
import script from "./ChatroomPage.vue?vue&type=script&lang=js&"
export * from "./ChatroomPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports